import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';
import getDigits from '../utils/getDigits';

const productFabric = product => {
    const rentOrBuy = () => {
        const array = [];

        if (product.hasBuy) {
            array.push('Продажа');
        }

        if (product.hasRent) {
            array.push('Аренда');
        }

        if (product.hasRent && product.hasBuy) {
            array.push('Аренда+Продажа');
        }

        return array;
    };

    return {
        id: product.id,
        name: product.name || '',
        images: product.images || [],
        priceStr: product.price,
        price: getDigits(product.price),
        points: product.properties?.bonuses_count?.value,
        isFavorite: product.isFavorite || false,
        properties: product.properties || {},
        hasBuy: product.hasBuy,
        hasRent: product.hasRent,
        tech: product.tech,
        cartPropsList: product.props,
        filterProps: {
            subcategory: product?.sections,
            rentOrBuy: rentOrBuy(),
            price: getDigits(product.price),
            liftingCapacity:
                product.properties?.gruz?.value || product.properties?.max_gruz?.value || product.properties?.capacity?.value || 0,
            maxBoomReach: product.properties?.height?.value || 0,
            weight: product.properties?.weight?.value || 0,
            drive: product.properties?.privod?.value || '',
            use: product.properties?.primenenie?.value || '',
            towerType: product.properties?.type_vishka?.value || '',
            workingHeight: product.properties?.work_height?.value || product.properties?.height?.value || '',
            verticalReach: product.properties?.vert_vyl?.value || '',
            horizontalReach: product.properties?.gor_vyl?.value || '',
            enginesType: product.properties?.type_engin?.value || '',
            liftingHeight: product.properties?.height?.value || '',
        },
    };
};

export class ProductStore {
    loading = false;
    toggleLoading = false;
    filterLoading = false;

    categories = [];
    categoryName = '';
    propNames = [];
    products = [];
    product = null;

    filterFields = [];
    filters = {};
    subcategories = [];

    // Actions
    // Gets
    getCategories = () => {
        this.loading = true;

        Api.fetch('catalog')
            .then(response => {
                if (response.success) {
                    this.categories = response?.result;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getProducts = categoryId => {
        this.loading = true;

        Api.fetch(`catalog/${categoryId}`)
            .then(response => {
                if (response.success) {
                    this.products = response?.result.map(product => productFabric(product));
                    this.categoryName = response?.breadcrumbs;
                    this.propNames = response?.props;
                    this.subcategories = response?.subcategories;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getProduct = productId => {
        this.loading = true;

        Api.fetch(`product/${productId}`)
            .then(response => {
                if (response.success) {
                    this.product = productFabric(response?.result);
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getFilterFields = categoryId => {
        this.filterLoading = true;

        Api.fetch(`catalog/${categoryId}/filters`)
            .then(response => {
                if (response.success) {
                    this.filterFields = response?.result;
                }
            })
            .finally(() => {
                this.filterLoading = false;
            });
    };

    // Posts
    toggleFavorite = (id, action) => {
        this.toggleLoading = true;

        if (action === 'remove') {
            Api.fetch('user/favorites', { product_id: id }, 'DELETE')
                .then(response => {
                    if (response.success) {
                        const productIndex = this.products.findIndex(product => product.id === id);
                        this.products[productIndex] = { ...this.products[productIndex], isFavorite: false };
                    }
                })
                .finally(() => {
                    this.toggleLoading = false;
                });
        } else {
            Api.fetch('user/favorites', { product_id: id }, 'PUT')
                .then(response => {
                    if (response.success) {
                        const productIndex = this.products.findIndex(product => product.id === id);
                        this.products[productIndex] = { ...this.products[productIndex], isFavorite: true };
                    }
                })
                .finally(() => {
                    this.toggleLoading = false;
                });
        }
    };

    // Sets
    setFilter = (name, value) => {
        this.filterLoading = true;
        this.filters = {
            ...this.filters,
            [name]: value,
        };

        setTimeout(() => {
            this.filterLoading = false;
        }, 500);
    };

    setFilterField = filter => {
        this.filterFields = [filter, ...this.filterFields];
    };

    resetStore = () => {
        this.loading = false;
        this.toggleLoading = false;
        this.filterLoading = false;

        this.categories = [];
        this.categoryName = '';
        this.propNames = [];
        this.products = [];
        this.product = null;

        this.filterFields = [];
        this.filters = {};
        this.subcategories = [];
    };
}

decorate(ProductStore, {
    loading: observable,
    toggleLoading: observable,
    filterLoading: observable,

    categories: observable,
    categoryName: observable,
    propNames: observable,
    products: observable,
    product: observable,

    filterFields: observable,
    filters: observable,
    subcategories: observable,

    getCategories: action,
    getProducts: action,
    getProduct: action,
    getFilterFields: action,

    toggleFavorite: action,

    setFilter: action,
    setFilterField: action,
    resetStore: action,
});
